import { ApiError } from './errors';

/**
 * Codes whose whole job is to carry a reason.
 *
 * For these the server's sentence is the useful one. "Bản tải này không có tệp video để chỉnh
 * sửa" tells the user exactly what happened; the generic "Dữ liệu không hợp lệ." tells them
 * nothing — and it hid a real bug, because every report of it read as "the form is broken"
 * rather than "we asked the server for the wrong record".
 *
 * The rest keep their localized text: codes like NOT_AUTHENTICATED carry short, sometimes
 * English server strings that are worse than a translated sentence.
 */
export const CODES_THAT_EXPLAIN_THEMSELVES = new Set(['VALIDATION_ERROR', 'UPSTREAM_ERROR', 'CONFLICT']);

/**
 * Choose what to show the user. `localize` returns the translated string for a code, or '' if
 * there is none — keeping this function free of any i18n dependency so it can be tested alone.
 */
export function pickErrorMessage(error: unknown, localize: (code: string) => string): string {
  if (error instanceof ApiError) {
    if (CODES_THAT_EXPLAIN_THEMSELVES.has(error.code) && error.message.trim()) {
      return error.message;
    }
    return localize(error.code) || error.message;
  }
  if (error instanceof Error) return error.message;
  return localize('INTERNAL_ERROR');
}
